import { AccessConfigType, RoleEnum } from "@cm/ui-modules";

export const AccessConfig: AccessConfigType = {
  dashboard: Object.values(RoleEnum).filter(
    (role) => role !== RoleEnum.DOC && role !== RoleEnum.REP,
  ),
  campaigns: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  'campaign-reports': [
    RoleEnum.PM,
    RoleEnum.SRV,
    RoleEnum.SGFX,
    RoleEnum.GFX,
    RoleEnum.AUD,
    RoleEnum.DTM,
  ],
  reports: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  'label-statistics': [
    RoleEnum.PM,
    RoleEnum.SRV,
    RoleEnum.SGFX,
    RoleEnum.GFX,
    RoleEnum.AUD,
    RoleEnum.DTM,
  ],
  details: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  medialibrary: [
    RoleEnum.PM,
    RoleEnum.SRV,
    RoleEnum.SGFX,
    RoleEnum.GFX,
    RoleEnum.AUD,
    RoleEnum.DTM,
  ],
  'video-editor': [
    RoleEnum.PM,
    RoleEnum.SRV,
    RoleEnum.SGFX,
    RoleEnum.GFX,
    RoleEnum.AUD,
    RoleEnum.DTM,
  ],
  messages: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  meetings: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  consent: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  privilege: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  configuration: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  contacts: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  workplaces: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  groups: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  specializations: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  'custom-fields': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  leads: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  'contacts.import': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  'batch-job': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  // Administration → Migrations (custom field → contact field): the same data-owning
  // roles as custom-fields / batch-job. Java additionally requires PM or TRUSTED_CLIENT.
  migrations: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  automations: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  presentations: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX],
  forms: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  challenges: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  courses: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  administrations: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  approve: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  // Narrower than 'approve' (which gates the whole module route): only PM/SRV can
  // add or delete policy rules — AUD (audit/oversight) and DTM stay read+edit-only,
  // same narrowing pattern as editbilling/addusage under the billing route key.
  'approve.managePolicyRules': [RoleEnum.PM, RoleEnum.SRV],
  billing: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SRF, RoleEnum.AUD, RoleEnum.ADM, RoleEnum.FIN],
  // Narrower than 'configuration' (which gates the whole page): gates the SuperAdmin
  // section inside it. SUPERADMIN is assignable only by writing abeuser.roles directly,
  // so no one reaches this through the privileges UI.
  'configuration.superAdmin': [RoleEnum.SUPERADMIN],
  sfdc: [],
  education: [],
  datamanager: [RoleEnum.DTM],
  segments: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  editbilling: [RoleEnum.ADM, RoleEnum.SRF],
  addusage: [RoleEnum.ADM, RoleEnum.SRV, RoleEnum.SRF],
  knowhow: [RoleEnum.PM, RoleEnum.ADM, RoleEnum.SRV, RoleEnum.SRF],
  // What's new archive: every role that sees the dashboard.
  'system-updates': Object.values(RoleEnum).filter(
    (role) => role !== RoleEnum.DOC && role !== RoleEnum.REP,
  ),
  // Create / publish / delete system updates (Java enforces PM on the /admin endpoints).
  'system-updates.manage': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.ADM],
  'ai-usage': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SRF, RoleEnum.AUD, RoleEnum.ADM, RoleEnum.FIN],
  'team-management': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  'team-management.profile': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  'contact-relations': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  designer: [RoleEnum.PM, RoleEnum.SRV, RoleEnum.SGFX, RoleEnum.GFX, RoleEnum.AUD, RoleEnum.DTM],
  workflow: [RoleEnum.PM, RoleEnum.ADM, RoleEnum.SRV, RoleEnum.SRF],
  'org-structure': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.DTM],
  'hierarchy-report': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
  'hierarchy-team-management': [RoleEnum.PM, RoleEnum.SRV, RoleEnum.AUD, RoleEnum.DTM],
};
